import { shareColumnsExtend, shareFormColumnsExtend } from './share';
export const REJECT_REASON_KINDS = [
  'admin_reject_apply',
  'cheif_pattern_making_officier_reject_product_design',
  'merchandiser_reject_order',
  'boss_reject_order',
  'product_design_overdue',
  'order_overdue',
  'sales_director_reject_order',
  'supplier_reject_order',
  'sales_director_reject_product_design',
  'supplier_reject_product_design',
  'supplier_boss_reject_product_design',
  'reject_product_design_make_plate',
  'reject_product_design_cut',
  'reject_product_design_sew',
  'admin_reject_order',
  'accessory_reject_order',
  'reject_product_design_craft',
]

const entityColumns = {
  id: {
    model_name: 'RejectReason',
    column_type: 'id',
    label_key_path: 'rejectReason.id',
  },
  created_at: {
    model_name: 'RejectReason',
    column_type: 'datetime',
    label_key_path: 'rejectReason.createdAt',
  },
  updated_at: {
    model_name: 'RejectReason',
    column_type: 'datetime',
    label_key_path: 'rejectReason.updatedAt',
  },
  reason: {
    model_name: 'RejectReason',
    column_type: 'string',
    label_key_path: 'rejectReason.reason',
  },
  kind: {
    model_name: 'RejectReason',
    column_type: 'enum',
    extra: {
      options: ['admin_reject_apply', 'cheif_pattern_making_officier_reject_product_design', 'merchandiser_reject_order', 'boss_reject_order', 'product_design_overdue', 'order_overdue', 'sales_director_reject_order', 'supplier_reject_order', 'sales_director_reject_product_design', 'supplier_reject_product_design', 'supplier_boss_reject_product_design', 'reject_product_design_make_plate', 'reject_product_design_cut', 'reject_product_design_sew', 'admin_reject_order', 'accessory_reject_order', 'reject_product_design_craft'],
    },
    label_key_path: 'rejectReason.kind',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
